import React from 'react';

const SchoolsContext = React.createContext();

export default SchoolsContext;